<template>
    <vx-card :title='(invoiceList === "waiting") ? $t("InvoicesWaiting") : $t("InvoicesFinished")'>
        <vs-table id="listCard"  ref="table" multiple v-model="selected" @selected="handleSelected" pagination :max-items="50" search :data="invoicesTable">

            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                <vs-button :disabled="selected.length === 0" class="mt-3 mr-6" style="float: left" color="success" icon-pack="feather" icon="icon-download" type="border" id="zipButton" @click='(invoiceList === "waiting") ? finishInvoices() : downloadInvoices()'>{{(invoiceList === "waiting") ? $t("Finish") : $t("Download")}}</vs-button>

                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ invoicesTable.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : invoicesTable.length }} of {{ invoicesTable.length }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>

                    <vs-dropdown-menu>

                        <vs-dropdown-item @click="itemsPerPage=10">
                            <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=20">
                            <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=50">
                            <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=100">
                            <span>100</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <template slot="thead">
                <vs-th sort-key="id">{{$t("Id")}}</vs-th>
                <vs-th></vs-th>
                <vs-th sort-key="client">{{$t("Client")}}</vs-th>
                <vs-th sort-key="date">{{(invoiceList === "waiting") ? $t("DateCreated") : $t("DateFinished")}}</vs-th>
                <vs-th sort-key="contract_hours">{{$t("ContractHours")}}</vs-th>
                <vs-th sort-key="total_work_time">{{$t("TotalTime")}}</vs-th>
                <vs-th sort-key="total_work_time">{{$t("Difference")}}</vs-th>
                <vs-th sort-key="task_num">{{$t("NumberOfTasks")}}</vs-th>
                <vs-th sort-key="first_file">{{$t("File")}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                    <vs-td :data="data[index].id">
                        {{ data[index].id }}
                    </vs-td>

                    <vs-td>
                        <vs-button size="small" style="float: left" class="mr-3" color="success" icon-pack="feather" icon="icon-eye" type="border" @click="$router.push({ name: 'invoice', params: { id: tr.id } })" ></vs-button>
                    </vs-td>

                    <vs-td :data="data[index].client">
                        {{ data[index].client }}
                    </vs-td>

                    <vs-td :data="data[index].date">
                        {{ moment(data[index].date).format('DD/MM/YYYY HH:mm') }}
                    </vs-td>

                    <vs-td :data="data[index].contract_hours">
                        {{ data[index].contract_hours }}
                    </vs-td>

                    <vs-td :data="data[index].total_work_time">
                        {{ data[index].total_work_time }}
                    </vs-td>

                    <vs-td :data="data[index].total_work_time - data[index].contract_hours">
                        {{ data[index].total_work_time - data[index].contract_hours}}
                    </vs-td>

                    <vs-td :data="data[index].task_num">
                        {{ data[index].task_num }}
                    </vs-td>

                    <vs-td :data="data[index].first_file">
                        {{ data[index].first_file }}
                    </vs-td>

                </vs-tr>
                </tbody>
            </template>

        </vs-table>
    </vx-card>
</template>
<script>

    export default {
        props: {
            invoiceList: {
                type: String,
                required: true
            },
        },
        data() {
            return {
                selected: [],
                invoicesRaw: null,
                itemsPerPage: 20,
                isMounted: false,

            }
        },
        computed: {
            currentPage() {
                if(this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            invoicesTable() {

                let list = [];
                if(this.invoicesRaw) {

                    for(let x = 0; x < this.invoicesRaw.length; x++) {

                        if (this.invoicesRaw[x].status === 0) {
                            list.push({id:this.invoicesRaw[x].invoice_id, client: this.$store.getters.companyClients[this.invoicesRaw[x].client_company_id].name, date: this.invoicesRaw[x].created, contract_hours: this.invoicesRaw[x].contract_hours, task_num: this.invoicesRaw[x].task_num, first_file: this.invoicesRaw[x].first_file, total_work_time:  this.invoicesRaw[x].total_work_time})
                        }else{
                            list.push({id:this.invoicesRaw[x].invoice_id, client: this.$store.getters.companyClients[this.invoicesRaw[x].client_company_id].name, date: this.invoicesRaw[x].finished, contract_hours: this.invoicesRaw[x].contract_hours, task_num: this.invoicesRaw[x].task_num, first_file: this.invoicesRaw[x].first_file, total_work_time:  this.invoicesRaw[x].total_work_time})
                        }


                    }

                }

                return list;

            }
        },
        methods: {
            handleSelected(tr) {
                //
            },
            updateInvoices() {
                this.$vs.loading({
                    background: "primary",
                    color: "fff",
                    container: "#listCard",
                    scale: 0.45
                });

                this.invoicesRaw = null;
                const thisIns = this;
                this.$http.get('/api/v1/invoicing_group/' + this.invoiceList)
                    .then(function (response) {
                        thisIns.invoicesRaw = response.data;
                        thisIns.$vs.loading.close("#listCard > .con-vs-loading");
                    })
                    .catch(function (error) {
                        thisIns.$vs.loading.close("#listCard > .con-vs-loading");
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            finishInvoices() {

                this.$vs.loading({
                    background: "primary",
                    color: "fff",
                    container: "#zipButton",
                    scale: 0.45
                });

                const thisIns = this;

                let list = [];
                for(let x = 0; x < this.selected.length; x++){
                    list.push(Number(this.selected[x].id));
                }

                this.$http.post('/api/v1/invoicing_group/finish', JSON.stringify(list)).then(function (response) {
                    thisIns.selected = [];
                    thisIns.$vs.loading.close("#zipButton > .con-vs-loading");
                    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
                        window.location.href = "/api/v1/invoicing_group/zip/" + response.data;
                    }else{
                        window.open("/api/v1/invoicing_group/zip/" + response.data, "_blank");
                    }
                    thisIns.updateInvoices();
                }).catch(function (error) {
                    thisIns.$vs.loading.close("#zipButton > .con-vs-loading");
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        position:'top-right',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            downloadInvoices() {

                this.$vs.loading({
                    background: "primary",
                    color: "fff",
                    container: "#zipButton",
                    scale: 0.45
                });

                const thisIns = this;

                let list = [];
                for(let x = 0; x < this.selected.length; x++){
                    list.push(Number(this.selected[x].id));
                }

                this.$http.post('/api/v1/invoicing_group/zip', JSON.stringify(list)).then(function (response) {
                    thisIns.$vs.loading.close("#zipButton > .con-vs-loading");
                    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
                        window.location.href = "/api/v1/invoicing_group/zip/" + response.data;
                    }else{
                        window.open("/api/v1/invoicing_group/zip/" + response.data, "_blank");
                    }
                }).catch(function (error) {
                    thisIns.$vs.loading.close("#zipButton > .con-vs-loading");
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        position:'top-right',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            }
        },
        watch: {
            invoiceList: function () {
                this.updateInvoices();
            }
        },
        mounted() {
            this.isMounted = true;
            this.updateInvoices()
        },
    }
</script>
